import historyGetHistory from './getHistory';
import historyHasSeenRoute from './hasSeenRoute';

export const getHistory = historyGetHistory;
export const hasSeenRoute = historyHasSeenRoute;
